import { Stack, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';

interface KeyValueProps {
  label: string;
  value: string;
  column?: true;
}

export const KeyValue = ({ label, value, column }: KeyValueProps) => (
  <Stack direction={{ md: column ? 'column' : 'row' }} gap={1}>
    <Typography fontWeight={fontWeights.fontWeightSemibold} width={200}>
      {label}
    </Typography>
    <Typography flex={1}>{value}</Typography>
  </Stack>
);
